import { customerType } from "./customers.type";

const initialState = {
  customersList: [],
};

function CustomerReducer(state = initialState, action) {
  switch (action.type) {
    case customerType.GET_CUSTOMERS_LIST: {
      return { ...state, customersList: action.payload };
    }
    default:
      return state;
  }
}

export default CustomerReducer;
